import { FC, useState } from 'react'
import shallow from 'zustand/shallow'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { useMeetingRequestByCompanyCountry } from '../../../graphql/meeting/hooks/useMeetingRequestByCompanyCountry'
import { MeetingViewInfoBox } from '../../meeting/infoBox/MeetingViewInfoBox'
import { useCompanySettingsStore } from '../CompanySettingsStore'
import { CompanySettingsRequestedMeetingsTable } from './CompanySettingsRequestedMeetingsTable'
import { MeetingRequestStatus } from '../../../types'
import { MeetingRequestDto } from '../../../types'

export const CompanySettingsMeetingRequestsTab: FC = () => {
  const [selected] = useCompanySettingsStore((state) => [state.selected], shallow)

  const { data, error, loading } = useMeetingRequestByCompanyCountry(selected.companyId, selected.country)

  const [meetingRequestsFilter, setMeetingRequestsFilter] = useState(MeetingRequestStatus.Requested)

  if (loading || error || !data || !data.getMeetingRequestsByCompanyCountry) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  } else {
    const filteredMeetingRequests: MeetingRequestDto[] = data.getMeetingRequestsByCompanyCountry.filter(
      (e) => e.status === meetingRequestsFilter,
    )
    return (
      <>
        <MeetingViewInfoBox
          data={filteredMeetingRequests}
          isRequestedMeetings
          meetingRequestsFilter={meetingRequestsFilter}
          onMeetingRequestsFilterChange={setMeetingRequestsFilter}
        />
        <CompanySettingsRequestedMeetingsTable requestedMeetings={filteredMeetingRequests} meetingRequestsFilter={meetingRequestsFilter} />
      </>
    )
  }
}
